import { Directive, Input, HostListener, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject, Subscription, pipe } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  selector: '[afterFilterChanged]'
})
export class AfterFilterChangedDirective implements OnDestroy {
  @Output()
  public afterFilterChanged: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  public filterChangeDelay: number = 750;

  private stream: Subject<any> = new Subject<any>();
  private subscription: Subscription;

  constructor() {
    this.subscription = this.stream
      .pipe(debounceTime(this.filterChangeDelay))
        .subscribe((value: any) => { this.afterFilterChanged.next(value); });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  @HostListener('filterChange', [ '$event' ])
  public onFilterChange(value: any): void {
    this.stream.next(value);
  }
}